/**
 * 
 * @param {*} date 
 * @param {*} years 
 * @returns 
 */
export function addYears(date, years) {
    date.setYear(date.getFullYear() + years);
    return date;
}

/**
 * 
 * @returns 
 */
export function getNowDate() {
    return new Date(Date.now())
}


